import React from 'react';
import StatusBadge from '@dashboard/components/StatusBadge';
import Tooltip from '@dashboard/components/Tooltip';
import getChargeStatusLabel from '@dashboard/services/status/getChargeStatusLabel';
import { is } from 'immutable';

function PaymentStatusBadge({ status, livemode, error, isAbandoned }) {
  if (!livemode) {
    return <StatusBadge status="Test">Test</StatusBadge>;
  }

  if (error && status !== 'paid') {
    return (
      <Tooltip label={error} align="left">
        <StatusBadge status={status} label={getChargeStatusLabel(status)} withInfoIcon />
      </Tooltip>
    );
  }

  // Show "Abandoned" for draft orders that were abandoned
  if (status === 'draft' && isAbandoned) {
    return <StatusBadge status="abandoned" label="Abandoned" />;
  }

  // Show "Recovered" badge when status is specifically "recovered"
  if (status === 'recovered') {
    return <StatusBadge status="recovered" label="Recovered" />;
  }

  // Show "Recovered" for positive status orders that were abandoned
  if (isAbandoned && (status === 'paid' || status === 'partially_paid' || status === 'active')) {
    return <StatusBadge status="recovered" label="Recovered" />;
  }

  return <StatusBadge status={status} label={getChargeStatusLabel(status)} />;
}

export default PaymentStatusBadge;
